import React from "react";
import ImmersiveSidebar from "../components/Sidebar/ImmersiveSidebar.js";
import PlayVideoPage from "../pages/Video/PlayVideoPage";
import { dashboardRoutes } from "../components/Routes/routingConstants";

interface VideoLayoutProps {
  history: any;
  location: any;
  match: any;
  staticContext?: any;
}

export default function VideoLayout(props: VideoLayoutProps) {
  const mainContent = React.useRef(null);

  return (
    <>
      <ImmersiveSidebar
        {...props}
        routes={dashboardRoutes}
        logo={{
          innerLink: "/dash/user",
          imgSrc: require("../assets/img/brand/DC_logo_for web_indigo.png").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <PlayVideoPage {...props} />
      </div>
    </>
  );
};
